import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'action-bar',
  templateUrl: './action-bar.component.html',
  styleUrls: ['./action-bar.component.scss']
})
export class ActionBarComponent {
  @Output() onSave = new EventEmitter<void>();
  @Output() onAddToFavorites = new EventEmitter<void>();
  @Output() onRemoveFromFavorites = new EventEmitter<void>();
  @Output() onDuplicate = new EventEmitter<void>();
  @Output() onDelete = new EventEmitter<void>();
  @Output() onCalculCEU = new EventEmitter<void>();
  @Output() onShare = new EventEmitter<void>();
  @Output() onSwitch = new EventEmitter<void>();
  @Output() onDownload = new EventEmitter<void>();
  @Output() onExport = new EventEmitter<void>();
  @Output() onSleep = new EventEmitter<void>();
  @Output() onResetPassword = new EventEmitter<void>();

  @Input() showSave?: any;
  @Input() showAddToFavorites?: any;
  @Input() showRemoveFromFavorites?: any;
  @Input() showDuplicate?: any;
  @Input() showDelete?: any;
  @Input() showCalculCEU?: any;
  @Input() showShare?: any;
  @Input() showSwitch?: any;
  @Input() showDownload?: any;
  @Input() showExport?: any;
  @Input() showSleep?: any;
  @Input() isSleepingMode?: boolean;
  @Input() showResetPassword?: any;

  constructor() {}

  get shouldShowSave(): boolean {
    return !!this.showSave;
  }

  get shouldShowAddToFavorites(): boolean {
    return !!this.showAddToFavorites;
  }

  get shouldShowRemoveFromFavorites(): boolean {
    return !!this.showRemoveFromFavorites;
  }

  get shouldShowDuplicate(): boolean {
    return !!this.showDuplicate;
  }

  get shouldShowDelete(): boolean {
    return !!this.showDelete;
  }

  get shouldShowCalculCEU(): boolean {
    return !!this.showCalculCEU;
  }

  get shouldShowShare(): boolean {
    return !!this.showShare;
  }

  get shouldShowSwitch(): boolean {
    return !!this.showSwitch;
  }

  get shouldShowDownload(): boolean {
    return !!this.showDownload;
  }

  get shouldShowExport(): boolean {
    return !!this.showExport;
  }

  get shouldShowSleep(): boolean {
    return !!this.showSleep;
  }

  get shouldShowResetPassword(): boolean {
    return !!this.showResetPassword;
  }
}
